export default __webpack_public_path__ + "static/media/ribbon.de332856.png";